'use client';

import { isProduction } from '@/lib/datadog/datadog.env';
import { useEffect } from 'react';

export default function DatadogInit() {
  useEffect(() => {
    if (isProduction) {
      import('@/lib/datadog/services/client');
    }
  }, []);

  return null;
}
